export default __webpack_public_path__ + "ui/assets/img/infinity-20.svg";